module.exports = __webpack_public_path__ + "static/fiorentini-918a1cc40bd17e76be2d03ad6bf3c8cc.png";